/* Side padding of the desktop header. Drop-down content uses it too, so it
   never runs closer to the viewport edge than the nav itself. Kept apart from
   Nav.style.ts, which imports ./components and would create a cycle. */
export const DESKTOP_NAV_GUTTER = '40px';
